export default __webpack_public_path__ + "static/media/cloud.8cc31fae.svg";